module.exports = __webpack_public_path__ + "img/money.43a111ba.svg";